var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.367718,
    y: 0.515179,
    width: 21.3966,
    height: 21.3966,
    rx: 3.30054,
    fill: "white",
    stroke: "#666666",
    strokeWidth: 0.227624
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8199 12.0031V6.47144H11.6902V12.0031H10.8199ZM11.2551 16.3351C10.5767 16.3351 9.93844 16.2063 9.34038 15.9486C8.74231 15.6909 8.21937 15.3391 7.77156 14.8933C7.32375 14.4475 6.97042 13.927 6.71155 13.3316C6.45268 12.7362 6.32324 12.1009 6.32324 11.4255C6.32324 10.6961 6.47723 10.0072 6.7852 9.3589C7.09316 8.71058 7.52237 8.15093 8.07282 7.67996L8.6787 8.28311C8.2108 8.66447 7.8463 9.12952 7.5852 9.67824C7.32411 10.227 7.19356 10.8094 7.19356 11.4255C7.19356 12.5422 7.59004 13.4953 8.38301 14.2846C9.17597 15.074 10.1333 15.4687 11.2551 15.4687C12.3865 15.4687 13.3463 15.074 14.1344 14.2846C14.9226 13.4953 15.3166 12.5422 15.3166 11.4255C15.3166 10.8094 15.1885 10.227 14.9322 9.67824C14.676 9.12952 14.309 8.66447 13.8315 8.28311L14.4374 7.67996C14.9915 8.15093 15.4217 8.71058 15.7278 9.3589C16.0339 10.0072 16.1869 10.6961 16.1869 11.4255C16.1869 12.1009 16.0575 12.7362 15.7986 13.3316C15.5398 13.927 15.1879 14.4475 14.7431 14.8933C14.2983 15.3391 13.7768 15.6909 13.1787 15.9486C12.5807 16.2063 11.9394 16.3351 11.2551 16.3351Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn1);
export default __webpack_public_path__ + "static/media/on1.dbec03a279743a8c307f120d4ff33ad1.svg";
export { ForwardRef as ReactComponent };